import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 240000, withCredentials: true });

export const analyzeFile = async (file, rating) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("lyrics_rating", rating);
  const { data } = await api.post("/songs/analyze-file", fd);
  return data;
};

export const analyzeUrl = async (url, rating) =>
  (await api.post("/songs/analyze-url", { url, lyrics_rating: rating })).data;

export const listSongs = async () => (await api.get("/songs")).data;

export const deleteSong = async (songId) => (await api.delete(`/songs/${songId}`)).data;

export const exchangeSession = async (sessionId, deviceId) =>
  (await api.post("/auth/session", { session_id: sessionId, device_id: deviceId })).data;

export const fetchMe = async () => (await api.get("/auth/me")).data;

export const logoutApi = async () => (await api.post("/auth/logout")).data;

export const startCheckout = async (lookupKey) =>
  (await api.post("/payments/checkout", { lookup_key: lookupKey, origin_url: window.location.origin })).data;

export const paymentStatus = async (sessionId) => (await api.get(`/payments/status/${sessionId}`)).data;
